module.exports = __webpack_public_path__ + "img/icon_gotop_top.15edf627.png";